module.exports = __webpack_public_path__ + "static/media/referral-management.10b2ab57.png";